import { jsx as _jsx } from "react/jsx-runtime";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
/**
 * Extends the `documentToReactComponents` method from `@contentful/rich-text-react-renderer`
 * and takes a richtext field from contentful and returns a ReactNode. The method gives the option of
 * adding renderNodeOptions which allows for custom wrapping of text, links and images.
 * @param content A RichText field from contentful
 * @param renderNodeOptions Options for rendering nodes
 * @example
 * {
 *   [BLOCKS.PARAGRAPH]: (node: any, children: any) => (
 *     <TextWrapper color={'currentColor'}>{children}</TextWrapper>
 *   ),
 *   [INLINES.HYPERLINK]: (node: any, children: any) => (
 *     <LinkWrapper href={node.data.uri}>{children}</LinkWrapper>
 *   ),
 * }
 * @returns A ReactNode with Link and Text elements
 */
export const renderContentfulRichText = (content, renderNodeOptions) => {
    return documentToReactComponents(content, {
        renderText: (text) => {
            return text
                .split('\n')
                .reduce((children, textSegment, index) => {
                // HACK: Don't know the side affects on changing this to something else
                // eslint-disable-next-line react/no-array-index-key
                return [...children, index > 0 && _jsx("br", {}, index), textSegment];
            }, []);
        },
        renderNode: { ...renderNodeOptions },
    });
};
//# sourceMappingURL=render-richtext.js.map